import { Mask } from '@hapvida/hapvida-core-components';

import type { ApplyCpfMaskProps } from './types';

export const applyCpfMask = ({
  currentValue,
  cursorPosition,
  previewValue,
}: ApplyCpfMaskProps) => {
  const cursorPreviewPosition = cursorPosition - 1;

  const invalidCharacter = /\D/.test(currentValue[cursorPreviewPosition]);

  const maskedText = Mask.cpf(currentValue);

  const shouldChangeInput =
    !invalidCharacter ||
    currentValue.length < previewValue.length ||
    currentValue[cursorPreviewPosition] === undefined;

  let newCursorPosition = cursorPosition;

  if (cursorPosition !== null) {
    newCursorPosition = invalidCharacter
      ? cursorPreviewPosition
      : cursorPosition;

    const specialCharacters = ['.', '-'];
    const lastCharacter = maskedText[cursorPreviewPosition];
    const isSpecialCharacter = specialCharacters.includes(lastCharacter);

    if (isSpecialCharacter && !invalidCharacter) {
      newCursorPosition += 1;
    }
    newCursorPosition = Math.max(newCursorPosition, 0);
  }

  return { maskedText, newCursorPosition, shouldChangeInput };
};
